import * as React from 'react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Button, Typography, Typography2 } from '@coursera/cds-core';

import { buildDegreeUrlAbsolute } from 'bundles/common/utils/urlUtils';
import type { EoiTerminalProps } from 'bundles/xddp/types';

import _t from 'i18n!nls/xddp';

import 'css!bundles/xddp/components/__styles__/landing/EoiTerminal';

const EoiTerminal = ({ slug, partnerName, shortName }: EoiTerminalProps) => {
  const degreeUrl = slug && buildDegreeUrlAbsolute(slug);

  return (
    <div className="rc-EoiTerminal">
      <Typography className="section-header-center" variant="h2">
        Thank you!
      </Typography>
      <Typography2 component="p" className="terminalCopy" variant="bodyPrimary">
        <FormattedMessage
          message={_t(
            'Thank you for your interest in the {shortName} program from {partnerName}. We will contact you by email with additional information.'
          )}
          shortName={shortName}
          partnerName={partnerName}
        />
      </Typography2>
      {degreeUrl && (
        <Button variant="primary" className="rc-EoiAction" onClick={() => window.open(degreeUrl, '_blank')}>
          {_t('Visit our website')}
        </Button>
      )}
    </div>
  );
};

export default EoiTerminal;
